module.exports = __webpack_public_path__ + "img/IPID-bike.3e678f8.svg";